import PATHS from '../constants';

function fetchService() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.SERVICE, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchService;